import * as server from "@/utils/http"

export const _pages = params => server.get("/error-config/pages", params);

export const _get = params => server.get("/error-config/get", params);

export const _save = params => server.post(params.id ? "/error-config/update" : "/error-config/save", params);

export const _updateStatus = params => server.get("/error-config/updateStatus", params);

export const _delete = params => server.get("/error-config/delete", params);

export const _baseData = params => server.get("/error-config/baseData", params);

export const _general = params => server.get("/error-config/general", params);

export const _copy = params => server.post("/error-config/copy", params);

export const _elementCondition = params => server.get("/element-condition/list", params);

export const _referralInstitutionDepartment = params => server.get("/error-config/referral-institution-department", params);

